import classNames from 'classnames'

import { Icon, SemanticICONS } from 'client/semantic-imports'

import { IconName, APP_ICONS, Size, AppPopup, IconVariant } from '..'

import styles from './app-icon.module.scss'

export type AppIconProps = {
  name: IconName
  variant?: IconVariant
  size?: Size
  disabled?: boolean
  inverted?: boolean
  pointer?: boolean
  popupText?: string
  onClick?: () => void
}

const AppIcon = (props: AppIconProps) => {
  const {
    name,
    variant = 'success',
    size = 'medium',
    disabled = false,
    inverted = false,
    pointer = false,
    popupText = '',
    onClick = null,
  } = props

  const IconComponent = () => (
    <Icon
      data-testid="app-icon"
      className={classNames(
        styles.appIcon,
        styles[variant],
        styles[size],
        disabled && styles.disabled,
        pointer && !disabled && styles.pointer
      )}
      name={APP_ICONS[name] as SemanticICONS}
      onClick={!disabled ? onClick : null}
      inverted={inverted}
    />
  )

  if (!popupText) {
    return <IconComponent />
  } else {
    return (
      <AppPopup text={popupText}>
        <IconComponent />
      </AppPopup>
    )
  }
}

export default AppIcon
